/**
 * About Section
 * Business story and mission
 */

import React from 'react';
import { usePortal } from '../../context/PortalContext';

const AboutSection = ({ 
  title = 'About Us',
  content,
  image
}) => {
  const { branding, portal } = usePortal();
  const aboutContent = content || portal?.landingPage?.about || 
    `Welcome to ${branding.businessName}. We're passionate about what we do and committed to providing the best experience for our customers.`;

  return (
    <section className="section">
      <div className="container">
        <div className={image ? 'grid grid-2' : ''} style={image ? styles.gridAlign : styles.noImageContent}>
          <div style={styles.content}>
            <h2 style={{ ...styles.title, color: branding.primaryColor }}>{title}</h2>
            <p style={styles.text}>{aboutContent}</p>
          </div>

          {image && (
            <div style={styles.imageWrap}>
              <img src={image} alt="About us" style={styles.image} />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

const styles = {
  gridAlign: {
    alignItems: 'center',
  },
  noImageContent: {
    maxWidth: '760px',
    margin: '0 auto',
  },
  content: {
    padding: '20px 0',
  },
  title: {
    fontSize: 'clamp(1.9rem, 4vw, 2.5rem)',
    fontWeight: '700',
    marginBottom: '20px',
  },
  text: {
    fontSize: '1.1rem',
    lineHeight: '1.8',
    color: '#555',
  },
  imageWrap: {
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
  },
  image: {
    width: '100%',
    height: 'auto',
    display: 'block',
  },
};

export default AboutSection;
